function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5ccb"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5ccb"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $6b93b7711b2719c3$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"z6yeP":"index.3540e0d2.js","e6RZH":"R&R-09.2d444351.png"}'));

var $ddf03668325a0849$exports = {};

$ddf03668325a0849$exports = new URL("../" + (parcelRequire("27Lyk")).resolve("e6RZH"), import.meta.url).toString();


class $4442881f93347908$var$blogPage {
    _blog = JSON.parse(localStorage.getItem("blogData"));
    _main = document.querySelector("main");
    _form = document.querySelector("#form");
    _post = document.querySelector("#post");
    _blogText = document.querySelector(".blogText");
    _comment = document.querySelector(".comments");
    _err = document.querySelector(".err");
    uploadComment(handler) {
        this._form?.addEventListener("click", function(e) {
            e.preventDefault();
            const blog = JSON.parse(localStorage.getItem("blogData"));
            const target = e.target.closest("#post");
            if (!target) return;
            const data = new FormData(form);
            const values = [
                ...data.entries()
            ];
            const info = {
                [values[0][0]]: values[0][1],
                [values[1][0]]: values[1][1],
                [values[2][0]]: values[2][1],
                uid: blog.uid
            };
            // console.log(info);
            handler(info);
        });
    }
    _renderBlog(blog) {
        let options = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        const date = new Intl.DateTimeFormat("en-US", options).format(this._blog.time);
        console.log(this._blog.text.split("\n", 500).join(" <br>"));
        const text = this._blog.text.split("\n", 500).join(" <br>");
        const html = `

  

  <section
  class="blogpage flex items-center justify-center flex-col w-8/12 mx-auto p-10 sm:w-full 2sm:w-full md:w-11/12 lg:w-9/12 xl:w-9/12"
>
  <h1
    class="mb-4 text-2xl font-[600] text-center sm:text-base 2sm:text-lg md:text-xl"
  >
  ${this._blog.title}
  </h1>
  <p class="text-base sm:text-sm md:text-base">${date}</p>
  <section class=" 2xl:w-10/12 sm:w-full 2sm:w-11/12 md:w-11/12 ">
    <img
      class="rounded-lg w-full h-full mb-6 mt-6"
      src="${this._blog.url}"
      alt=""
    />
  </section>
  <p class="text-base sm:text-xs 2sm:text-sm">
  ${text}
  </p>
</section>

  <hr />

  

    `;
        this._main.insertAdjacentHTML("afterbegin", html);
    }
    _renderComments(data, time) {
        const html = `
   

<div class="flex space-x-4 mb-6">
<div class="rounded-full h-12 w-12">
  <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($ddf03668325a0849$exports)))}" alt="" />
</div>
<div class="flex-1 space-y-6 py-1">
  <div class="">
    <div class="flex items-center justify-center">
      <div class="h-fit w-full flex rounded">
        <h1 class="pr-6 font-bold">${data.name}</h1>
        <h6 class="text-sm sm:text-xs">${time}</h6>
      </div>
    </div>
    <div class="h-fit w-full text-sm sm:text-xs break-all rounded">
    ${data.comment}
    </div>
  </div>
</div>
</div>
    `;
        const checked = data !== "" ? html : ` <p class="err text-center">No Comments Yet...</p>`;
        this?._comment?.insertAdjacentHTML("afterbegin", checked);
        if (data !== "") document.querySelector(".err").style.display = "none";
    }
}
var $4442881f93347908$export$2e2bcd8739ae039 = new $4442881f93347908$var$blogPage();


(0, $4442881f93347908$export$2e2bcd8739ae039)._renderBlog();


//# sourceMappingURL=index.3540e0d2.js.map
